import { MemberImportResponse } from '@app/_services';

export class MembersStateModel {
  import: { data?: FormData; googleSheetUrl?: string; result: MemberImportResponse };
  list: Member[];
  groups: MemberGroup[];
}

export class MemberGroup {
  id: string;
  // paymentRecipients: Member[];
  names: string[];
  members: Member[];
  isMissingPaymentRecipient: boolean;
  memberWithConfigurationError: boolean;
}

export class Member {
  id: string;
  name: string;
  email: string;
  mobile: string;
  tags: string[];
  isPaymentRecipient: boolean;
  group: string;
  importTag?: string;
  ignoreInActivities: boolean;
  isCreatingWallet?: boolean = false;
  walletBalance?: number;
  walletTransactions?: Transaction[];
}

export class Transaction {
  amount: number;
  newBalance: number;
  timestamp: Date;
  text: string;
  createdBy: string;
}
